module.exports = "<div>\n\t<hr>\n    <div class=\"text-right\">\n        <button type=\"button\" ng-disabled=\"vm.loading === true\" ng-click=\"vm.export()\" class=\"btn m-l-sm btn-success m-t-lg\">\n            <span>Export</span>\n        </button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/reports/student-overview/student-overview.html
// module id = 64
// module chunks = 0